module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-tree-container"
  }, [_c('el-row', {
    staticClass: "content-bottom-padded",
    staticStyle: {
      "padding-top": "15px",
      "margin-left": "20px"
    }
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus",
      "disabled": _vm.isDisable
    },
    on: {
      "click": _vm.updateCategory
    }
  }, [_vm._v("保存分类")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tree-background block"
  }, [_c('el-tree', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.categoryList,
      "default-expand-all": "",
      "expand-on-click-node": false
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('ul', {
          staticClass: "custom-tree-node"
        }, [_c('li', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.category_name),
            expression: "data.category_name"
          }],
          attrs: {
            "placeholder": "分类名称"
          },
          domProps: {
            "value": (data.category_name)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data, "category_name", $event.target.value)
            }
          }
        }), _vm._v(" "), (data.level < 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.append(data.children, data.level)
            }
          }
        }, [_vm._v("新增分类\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.sort),
            expression: "data.sort"
          }],
          staticStyle: {
            "width": "65px"
          },
          attrs: {
            "placeholder": "分类排序"
          },
          domProps: {
            "value": (data.sort)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data, "sort", $event.target.value)
            }
          }
        })]), _vm._v(" "), _c('li', {
          staticClass: "category-icon"
        }, [_c('span', {
          on: {
            "click": function($event) {
              return _vm.handleImgChange(data)
            }
          }
        }, [(data.image_url) ? _c('img', {
          attrs: {
            "src": _vm.wximageurl + data.image_url
          }
        }) : _c('i', {
          staticClass: "iconfont icon-image"
        })])]), _vm._v(" "), _c('li', [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.switchAuth(node, data)
            }
          },
          model: {
            value: (data.recommend),
            callback: function($$v) {
              _vm.$set(data, "recommend", $$v)
            },
            expression: "data.recommend"
          }
        })], 1), _vm._v(" "), _c('li', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.recommend_sort),
            expression: "data.recommend_sort"
          }],
          staticStyle: {
            "width": "65px"
          },
          attrs: {
            "placeholder": "排序"
          },
          domProps: {
            "value": (data.recommend_sort)
          },
          on: {
            "change": function($event) {
              return _vm.editRecommendSort(node, data)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data, "recommend_sort", $event.target.value)
            }
          }
        })]), _vm._v(" "), _c('li', [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.switchFrontendShow(node, data)
            }
          },
          model: {
            value: (data.frontend_show),
            callback: function($$v) {
              _vm.$set(data, "frontend_show", $$v)
            },
            expression: "data.frontend_show"
          }
        })], 1), _vm._v(" "), _c('li', [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.switchDisabled(node, data)
            }
          },
          model: {
            value: (data.disabled),
            callback: function($$v) {
              _vm.$set(data, "disabled", $$v)
            },
            expression: "data.disabled"
          }
        })], 1), _vm._v(" "), (data.created) ? _c('li', [_vm._v(_vm._s(_vm._f("datetime")(data.created)))]) : _c('li'), _vm._v(" "), _c('li', [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchInternalRoute('goodsphysical'),
              query: {
                category: data.category_id
              }
            }
          }
        }, [_vm._v("\n                        查看商品\n                    ")]), _vm._v(" "), _c('span', {
          staticClass: "remove-category",
          on: {
            "click": function($event) {
              return _vm.deleteCategory(node, data)
            }
          }
        }, [_c('i', {
          staticClass: "iconfont icon-trash-alt"
        })])], 1)])
      }
    }])
  }), _vm._v(" "), _c('SideBar', {
    attrs: {
      "visible": _vm.show_batchStore,
      "title": "分类批量同步到店铺",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_batchStore = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "编辑提示",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v("\n              如果输入店铺id(英克id)则店铺类型和区域类型无效。"), _c('br'), _vm._v("\n              店铺类型和店铺区域不能同时选择"), _c('br'), _vm._v("\n              店铺区域属于怡康自营门店和第三方门店无关\n            ")])])], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类id："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n                " + _vm._s(_vm.category_id) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺类型： "
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "选择店铺类型"
    },
    model: {
      value: (_vm.params.shop_type_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "shop_type_id", $$v)
      },
      expression: "params.shop_type_id"
    }
  }, [_vm._l((_vm.shop_type_list_default), function(shop) {
    return _c('el-option', {
      key: shop.shop_type_id,
      attrs: {
        "label": shop.shop_type_name,
        "value": shop.shop_type_id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.shop_type_list), function(shop) {
    return _c('el-option', {
      key: shop.shop_type_id,
      attrs: {
        "label": shop.shop_type_name,
        "value": shop.shop_type_id
      }
    })
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区域分类"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "所属大区",
      "options": _vm.new_office_area,
      "props": {
        checkStrictly: true
      },
      "clearable": ""
    },
    on: {
      "change": _vm.handleOfficeChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺id(多个店铺用英文逗号隔开)： "
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请填写店铺id"
    },
    model: {
      value: (_vm.districtId),
      callback: function($$v) {
        _vm.districtId = $$v
      },
      expression: "districtId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 50%"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.saveSynsc
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-category"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.appendTop(_vm.categoryList)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("增加顶级分类")])])], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "custom-tree-node-title"
  }, [_c('li', [_vm._v("分类名称")]), _vm._v(" "), _c('li', [_vm._v("分类排序")]), _vm._v(" "), _c('li', [_vm._v("图片")]), _vm._v(" "), _c('li', [_vm._v("推荐位显示")]), _vm._v(" "), _c('li', [_vm._v("推荐位排序")]), _vm._v(" "), _c('li', [_vm._v("前端展示")]), _vm._v(" "), _c('li', [_vm._v("是否禁用")]), _vm._v(" "), _c('li', [_vm._v("创建时间")]), _vm._v(" "), _c('li', [_vm._v("操作")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e1b848f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e1b848f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/category.vue
// module id = 2647
// module chunks = 0